export const LOGIN  = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const LOGIN_ADMIN  = 'LOGIN_ADMIN';
export const LOGOUT_ADMIN = 'LOGOUT_ADMIN';
export const LOGIN_GOOGLE = 'LOGIN_GOOGLE';
export const LOGIN_GITHUB = 'LOGIN_GITHUB';
export const LOGIN_TWITTER = 'LOGIN_TWITTER';
export const LOGIN_FACEBOOK = 'LOGIN_FACEBOOK';



/** WEBPACK FOOTER **
 ** ./app/constants/userTypes.js
 **/